import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, Page, BaseNacional } from 'eddydata-lib';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BaseNacionalService extends BaseResourceService<BaseNacional> {

  constructor(
    protected injector: Injector
  ) {
    super(`bases-nacionais`, injector);
  }

  importarPlanilha(orgaoId: number, itens: any[]) {
    return this.http.post<any>(
      `${this.login.cidade.id}/${this.api}/importar`,
      { orgao_id: orgaoId, itens },
      this.httpOptions()
    );
  }

  importarPlanilhaOBM(orgaoId: number, itens: any[]) {
    return this.http.post<any>(
      `${this.login.cidade.id}/${this.api}/importar-obm`,
      { orgao_id: orgaoId, itens },
      this.httpOptions()
    );
  }
}
